import "../src/global/global-pc"

import "@modules/vue-modals/ad-free"
import "@modules/vue-modals/age-verification"
import "@modules/vue-modals/coins"

import "@modules/location/LocationSelector"
import "@modules/solads/solads"

import "@modules/stars/styles-pc.css"
import "@modules/stars/stars-post"
import "@modules/stars/my-posts/pc.css"
import "@modules/stars/not-logged-in-box.css"
import StarsPost from "@modules/stars/stars-post/StarsPost"

const posts = new StarsPost(this)

posts.loadCurrentStarsPostsFilterForMyPosts()
